var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-top"},[_c('div',{staticClass:"top-info"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),(_vm.links)?_c('div',{staticClass:"top-links"},_vm._l((_vm.links),function(link){return _c('span',[_c('router-link',{attrs:{"to":link.router}},[_vm._v(_vm._s(link.text))])],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ec3e71","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/HeaderTop.vue
// module id = null
// module chunks = 